'use client';

import { c as _c } from "react/compiler-runtime";
import { reactive } from '@legendapp/state/react';
import DraggableXContainer from '@/components/DraggableXContainer';
import type { CmsPageSubNav } from '@/services/cms-sdk/schemas/models/CmsPageSubNav';
import { PageSubNavIndicator } from './PageSubNavIndicator';
import { PageSubNavLink } from './PageSubNavLink';
import { type PageSubNavItem, useInitSubNav } from './useInitSubNav';
const ReactivePageSubNavLink = reactive(PageSubNavLink);
export type PageSubNavProps = Partial<CmsPageSubNav>;
export function PageSubNav(t0) {
  const $ = _c(4);
  const {
    enabled: t1,
    items
  } = t0;
  const enabled = t1 === undefined ? false : t1;
  if (!enabled || !items?.length) {
    return null;
  }
  let t2;
  if ($[0] !== items) {
    t2 = mapItems(items);
    $[0] = items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <PageSubNavInner items={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
interface PageSubNavInnerProps {
  items: PageSubNavItem[];
}
function PageSubNavInner(t0) {
  const $ = _c(14);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = {
      items
    };
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [pageSubNavState, ref] = useInitSubNav(t1);
  const t2 = pageSubNavState.activeSectionLink;
  let t3;
  if ($[2] !== items || $[3] !== pageSubNavState) {
    let t4;
    if ($[5] !== pageSubNavState) {
      t4 = item => <ReactivePageSubNavLink key={item.id} href={item.href} $active={() => pageSubNavState.activeItem()?.id === item.id}>{item.label}</ReactivePageSubNavLink>;
      $[5] = pageSubNavState;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = items.map(t4);
    $[2] = items;
    $[3] = pageSubNavState;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== pageSubNavState.indicatorState) {
    t4 = <PageSubNavIndicator indicatorState$={pageSubNavState.indicatorState} />;
    $[7] = pageSubNavState.indicatorState;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== pageSubNavState.activeSectionLink || $[10] !== ref || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="bg-white card-shadow fixed z-10 top-0 w-full py-4  px-4 flex justify-center"><DraggableXContainer ref={ref} className="tabs  px-4" activeElement$={t2}>{t3}{t4}</DraggableXContainer></div>;
    $[9] = pageSubNavState.activeSectionLink;
    $[10] = ref;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function mapItems(items?: Record<string, string>): PageSubNavItem[] {
  return items ? Object.entries(items).map(([key, value]) => {
    if (key.startsWith('element:')) {
      const blockId = Number(key.split(':')[1]);
      const blockContainerId = `element-${blockId}`;
      return {
        id: key,
        sectionContainerId: blockContainerId,
        href: `#${blockContainerId}`,
        label: value,
        blockId
      };
    }
    return {
      id: key,
      sectionContainerId: key,
      href: `#${key}`,
      label: value
    };
  }) : [];
}